import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MyPATPopMenu from "../../../common/MyPATPopMenu";
import { Button, Chip, Grid, Tooltip } from "@material-ui/core";
import { MoreVert as MoreIcon } from "@material-ui/icons";
import { BonusWarningPopup, SaveAndProceed } from "../PopUp";
import { WithStyles, withStyles } from "@material-ui/core";
import { headerStyles } from "../../styles";
import awaitingRequestStyle from '../../styles/AwaitingRequest';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import _ from "lodash";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { contentManagementAction } from "../../reducers/contentMangementData";
import classNames from "classnames";
import courseManagementServices from "../../service/courseManagementServices";
import EditLockedInfoPopUp from "../PopUp/EditLockedInfoPopUp";
import { checkForCreatedByUser, checkForCreationForRight, checkForEditRight, checkForPublishRight, getRequestId, redirectionToCourseManagement } from '../../helpers/helpers';
import { CONTENT_STATES, CONTENT_STATUS, MODULES,  } from '../../../../constants/comman';
import { PUBLISH_OPTIONS, REQUEST_CHANGES, COURSE_CHANGE, COURSE_CHANGE_CONFIRMATION, COURSE_CHANGE_TYPE, CHANGE_LABEL, CHANGE_TYPE, CONTENT_LOCATION, REQUEST_CHANGES_KEYS } from '../../Constants/constants';
import { convertDateToHHMM, formatDateToDayMonthYear, getLabel, getQueryParams } from '../../../../utils';
import { rejectCourse } from '../../actions/courseManagementActions';
import { REQUEST_STATUS, COURSE_CHANGE_TAB, COURSE_CHANGE_CONFIMATION_POPUP,  } from '../../types/enums/RequestStatus';
import { MyPATDialog } from "../../../common";
import cx from 'classnames';
import ACLService from "../../../acl/services/aclService";

interface HeadingComponentProps extends WithStyles<typeof headerStyles> {
  classes: any;
  name: string;
  status: string;
  handleSave: Function;
  match: any;
  history: any;
  activeComponent?: string;
  handlePublish?: Function;
  disablePublish: boolean;
  hideSave: boolean;
  hidePublish: boolean;
  showEdit: boolean;
  handleEdit: Function;
  isSaveRequiredFromProps: boolean;
  coursePlanDone: boolean;
  basicInfoDone: boolean;
  advancedSettingsDone: boolean;
  basicInfoValid: boolean;
  advancedSettingsValid: boolean;
  activeTab: string;
  handleComponentSwitching:Function;
  handleTabSwitch:Function;
  isSaveDisable:boolean;
  treeData: any;
  canPublishCourse: boolean;
  resetAllState: Function;
  isGoalCombo?: any;
  disableEdit: boolean;
  hasDuplicateRight: boolean;
  duplicate:any;
  coursePlanData:any;
  stopPollingStatusApi:boolean;
  getPackageByIdData: any;
  hideDuplicate?: boolean;
  handleReject?: Function;
  rejectCourse: Function,
  courseRequest: any,
  courseChangeData: any,
  courseChangePayload: any,
  isDifferentUser: boolean,
}
// interface HeadingComponentProps {
//     name: string,
//     status: string,
//     handleSave?: Function
// }
interface HeadingComponentStates {
  isDailogOpen: boolean;
  treeDataChange:boolean;
  isSaveClick: Boolean;
  showEditLockPopUp:boolean;
  viewChangeVisible: boolean,
  activeTab: any,
}
const moreMenuItems = [
  {
    type: "callback",
    id: 1,
    to: "",
    img: "",
    text: "Set Display Name",
  },
];

class HeadingComponent extends PureComponent<
  HeadingComponentProps,
  HeadingComponentStates
> {
  intervalId: any = null;
  constructor(props: HeadingComponentProps) {
    super(props);
    this.state = {
      isDailogOpen: false,
      treeDataChange: false,
      isSaveClick: false,
      showEditLockPopUp: false,
      viewChangeVisible: false,
      activeTab: 0,
    };
  }
  dateChanges = [CHANGE_TYPE.START_DATE, CHANGE_TYPE.END_DATE];
  processedList = [REQUEST_STATUS.ACCEPTED, REQUEST_STATUS.REJECTED, REQUEST_STATUS.CLOSED];

  toggleIsDialogOpen = () => {
    this.setState((prevState: any) => ({
      isDailogOpen: !prevState.isDailogOpen,
      treeDataChange: false,
    }));
  };
  componentDidMount() {
    this.checkCoursePublishProcess();
    setTimeout(() => {
      this.checkPublishStatus();
    }, 1000);
  }
  componentDidUpdate(nextProps: any, nextState: any) {
    if (
      nextProps &&
      nextProps.treeData &&
      Object.keys(nextProps.treeData).length > 0
    ) {
      if (
        !_.isEqual(nextProps.treeData, this.props.treeData) &&
        !this.state.isSaveClick
      ) {
        this.setState({ treeDataChange: true });
      }
    } 
     if ((nextProps.coursePlanData !== this.props.coursePlanData)||(nextProps.treeData !== this.props.treeData)) {
       const dataKey= !_.isEmpty(this.props.treeData)?'treeData':'coursePlanData';
       const nextId=_.get(nextProps,`${dataKey}._id`,'');
        const prevId= _.get(this.props,`${dataKey}._id`,'');
        this.checkCoursePublishProcess();
        if(nextId!==prevId){
          this.checkPublishStatus();
        }
    }
    if(nextProps.stopPollingStatusApi!==this.props.stopPollingStatusApi){
        if(this.props.stopPollingStatusApi){
            clearInterval(this.intervalId);
        }else{
           this.checkPublishStatus();
        }
    }
    if (nextProps.courseChangeData !== this.props.courseChangeData) {
      this.setState({ viewChangeVisible: true });
      if (!((this.props.courseChangeData.reorderedChanges || []).length)) {
        this.setState({ activeTab: 1 });
      }
    }
  }

  checkCoursePublishProcess = () => {
    const treeData = this.props.treeData;
    const coursePlan = this.props.coursePlanData;
    let isUpdateLocked = false;
    if (treeData) {
      isUpdateLocked = treeData.isUpdateLocked;
    } else if (coursePlan) {
      isUpdateLocked = coursePlan.isUpdateLocked;
    } 
     
      if(!this.props.hidePublish){  
         this.setState({
            showEditLockPopUp: isUpdateLocked || false,
         });
       }
  };
  checkPublishStatus = () => {
   if(this.props.hidePublish){
     return;
   } 
    const { showEditLockPopUp } = this.state;
    let isApiInProcess = false;
    const dataKey= !_.isEmpty(this.props.treeData)?'treeData':'coursePlanData';
    let viewPlanDataId =_.get(this.props,`${dataKey}._id`, "");
    clearInterval(this.intervalId);
    this.intervalId=null;
    if (!showEditLockPopUp && viewPlanDataId) {
      this.intervalId = setInterval(async () => {
        if (!isApiInProcess) {
          isApiInProcess = true;
          try {
            const res = await courseManagementServices.getPublishProcessStatus(
              viewPlanDataId
            );
            const isUpdateLocked = res.isUpdateLocked || false;
            isApiInProcess = false;
            if (isUpdateLocked) {
              clearInterval(this.intervalId);
            }
            if (this.state.showEditLockPopUp !== isUpdateLocked) {
              this.setState({
                showEditLockPopUp: isUpdateLocked,
              });
            }
          } catch (err) {
            console.log("Error in combinedPhase", err);
            clearInterval(this.intervalId);
          }
        }
      }, 10000);
    }
  };
  reDirectLandingPage=()=>{
    this.props.history.push(`/course-Management/`);
  }
  toggleEditPopUp=()=>{
    this.setState({showEditLockPopUp:!this.state.showEditLockPopUp})
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  }
  handleBack = () => {
    const id = _.get(this.props, "match.params.id");
    const { history, activeComponent, activeTab, resetAllState } = this.props;
    this.setState({ treeDataChange: false }, () => {
      resetAllState();
      history.push(`/course-Management/`);
    });
    // history.goBack();

    // if (activeComponent === "CoursePlan" && activeTab === "coursePlan" && this.props.match.params.type !== "Goals") {

    //   history.push(`/course-Management/create-standard-course/`);

    // } else if ((activeTab === "advancedSettings" || activeTab === "basicInfo" || activeTab === "coursePlan") && this.props.match.params.type !== "Goals") {

    //   this.props.handleComponentSwitching('CoursePlan');
    //   this.props.handleTabSwitch("", 0);
    // } else if(activeComponent === "CreateCoursePlan" && this.props.match.params.type === "Goals" ){
    //   history.push(`/course-Management/create-combo-course/`);
    // }
    // else
    //   history.goBack();
    // if( activeComponent === 'Selected') {

    //   // this.toggleIsDialogOpen()
    //   // this.setState({isBack: true})
    // }
    // else{

    // let url = `/course-Management/create-standard-course/${id}`;
    // if(this.props.match.path === "/course-Management/create-combo-course/:id"){
    //   url = `/course-Management/create-combo-course/`;
    // }
    // history.push(url);
    // }
  };


  handleTabClick = (tabIndex: number) => {
    if (tabIndex !== this.state.activeTab) {
        this.setState({ activeTab: tabIndex });
    }
  };

  handleViewChanges = () => {
    const { handlePublish } = this.props;
    handlePublish && handlePublish();
  }

  handleConfirmation = (proceedRequest: boolean) => {
    const { courseChangePayload, isDifferentUser } = this.props;
    const userData = ACLService.getUserDetailsFromStorage();
    const { packageChangeRequestId, packageId } = courseChangePayload;
    this.setState({ viewChangeVisible: false });
    const proceedPayload = {
      proceedRequest,
      packageChangeRequestId,
      packageId,
      aclMetaData: { clientId: userData.authenticatedUser.clientId._id },
      loggedUser: {
        email: userData.authenticatedUser.email,
        _id: userData.authenticatedUser._id,
      }
    }
    courseManagementServices.updateCoursePlanAndProceed(proceedPayload).then((res: any) => {
      if (res.statusCode === 200) {
        if (proceedRequest && !isDifferentUser) {
          this.updateCoursePlan(courseChangePayload);
          return;
        }
      }
      proceedRequest && this.reDirectLandingPage();
    }).catch((err: any) => {
      this.reDirectLandingPage();
    })
  }

  updateCoursePlan(courseChangePayload: any) {
    courseManagementServices.updateCoursePlan(courseChangePayload, null, null, true).then((res: any) => {
      redirectionToCourseManagement(REQUEST_STATUS.AWAITING);
    })
  }

  proceedAfterConfirmation(proceedRequest: boolean) {
    if (!proceedRequest) {
      this.reDirectLandingPage();
      return;
    }
    redirectionToCourseManagement(REQUEST_STATUS.AWAITING);
  }

  getArrowPathName(property: string, value: string, arrowNotVisible?: boolean) {
    if (!value) {
        return <></>;
    }
    return (<>
        {!arrowNotVisible &&
            <img className='arrowIcon' src='/assets/svg/course-plan-request/arrow-ic.svg' alt='Left Arrow' />}
         {' '} {property} {value} 
    </>);
  }

  getCoursePlanChange(change: any) {
    if (!this.dateChanges.includes(change.changeType)) {
      return;
    }
    const path = change.entityPath;
    const isStartDateChanges = change.changeType === CHANGE_TYPE.START_DATE;
    const imageUrl = isStartDateChanges ? CHANGE_LABEL.START_DATE.ICON : CHANGE_LABEL.END_DATE.ICON;
    const clockUrl = isStartDateChanges ? CHANGE_LABEL.START_DATE.CLOCK_ICON : CHANGE_LABEL.END_DATE.CLOCK_ICON;
    return (<li>
        <div className='phaseTitle'>
                {path && 
                <>
                  {path.content && <>
                  <span className='iconCol'>
                      <img src='/assets/svg/course-plan-request/test.svg' alt='Test' />
                  </span>
                  <p>{path.content.name || ''}  -</p>&nbsp;
                </>
                }
                {this.getArrowPathName(CONTENT_LOCATION.PHASE, path.phase && path.phase.phaseNo, true)}
                {this.getArrowPathName(CONTENT_LOCATION.WEEK, path.week && path.week.weekNo)}
                {this.getArrowPathName(CONTENT_LOCATION.SUBJECT, path.subject && path.subject.subjectName)}
                {this.getArrowPathName(CONTENT_LOCATION.CHAPTER, path.chapter && path.chapter.chapterName)}
                {this.getArrowPathName(CONTENT_LOCATION.CONCEPT, path.concept && path.concept.conceptName)}
            </>}&nbsp;
        </div>
        <div className = 'datePhaseLabel'>
        {getLabel(isStartDateChanges, !!(path.content))}
        </div>
        <div className='paraSection'>
            <span className='iconCol'>
                <img src={imageUrl} alt='Calendar' />
            </span>
            <p>{formatDateToDayMonthYear(change.proposedChange)} </p>
            {path.content && <span className='iconCol'>
                <img src={clockUrl} alt='Calendar' />
            </span>}
            <p>{path.content && convertDateToHHMM(change.proposedChange)}</p>
        </div>
        <p className='otherInfo'>Previously
            {(path && !path.content) && <>
            {this.getArrowPathName(CONTENT_LOCATION.PHASE, path.phase.phaseNo, true)}
            {this.getArrowPathName(CONTENT_LOCATION.WEEK, path.week && path.week.weekNo, true)}
            {this.getArrowPathName(CONTENT_LOCATION.SUBJECT, path.subject && path.subject.subjectName, true)}
            {this.getArrowPathName(CONTENT_LOCATION.CHAPTER, path.chapter && path.chapter.chapterName, true)}
            {this.getArrowPathName(CONTENT_LOCATION.CONCEPT, path.concept && path.concept.conceptName, true)}
            </>}
            {(path && path.content) && <>
                    &nbsp;{isStartDateChanges ? CHANGE_LABEL.START_DATE.TEST_LABEL : CHANGE_LABEL.END_DATE.TEST_LABEL}
                </>}
            &nbsp;: {formatDateToDayMonthYear(change.currentValue)} {path.content && convertDateToHHMM(change.currentValue)}
        </p>
    </li>);
}

  getDateChanges() {
    const { activeTab } = this.state;
    const { courseChangeData } = this.props;
    const dateChanges = courseChangeData.dateChanges || [];
    return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_CONFIMATION_POPUP.DATE_CHANGE })}>
            <h1 className='mainHeading'><strong>{dateChanges.length}</strong> new requests</h1>
            <div className='phaseBlockSection'>
                {!!dateChanges.length && <div className='phaseBlockCol'>
                    <ul className='phaseList'>
                        {
                            dateChanges.map((change: any) =>
                                this.getCoursePlanChange(change)
                            )
                        }
                    </ul>
                </div>}
            </div>
    </div>);
  }
  getReorderChanges() {
    const { activeTab } = this.state;
    const { courseChangeData } = this.props;
    const reorderChanges = courseChangeData.reorderedChanges || [];
    return (<div className={cx('coursePlanRequestContent', { 'active': activeTab === COURSE_CHANGE_CONFIMATION_POPUP.REORDERED })}>
        <h1 className='mainHeading'><strong>{reorderChanges.length}</strong> new requests</h1>
        <div className='phaseBlockSection'>
            {reorderChanges.map((change: any) => {
               {
                const oldPath = change.oldPath;
                const newPath = change.newPath;
                return ((change.changeType === COURSE_CHANGE_TYPE.REORDER) && <>
                    <div className='phaseBlockCol'>
                        <div className='phaseInfoGroup'>
                            {newPath && <ul className='phaseInfo'>
                                <li className='whiteSpaceNoWrap'>Phase: <strong>{newPath.phase && newPath.phase.phaseNo}</strong></li>
                                <li className='whiteSpaceNoWrap'>Week: <strong>{newPath.week && newPath.week.weekNo}</strong></li>
                                <li>{newPath.subject && newPath.subject.subjectName}</li>
                                <li>{newPath.chapter && newPath.chapter.chapterName}</li>
                                <li>{newPath.concept && newPath.concept.conceptName}</li>
                            </ul>}
                            {oldPath && <ul className='phasePrevInfo'>
                                <li className='whiteSpaceNoWrap'>Previously in : Phase: {oldPath.phase && oldPath.phase.phaseNo}</li>
                                <li className='whiteSpaceNoWrap'>Week: {oldPath.week && oldPath.week.weekNo}</li>
                                <li>{oldPath.subject && oldPath.subject.subjectName}</li>
                                <li>{oldPath.chapter && oldPath.chapter.chapterName}</li>
                                <li>{oldPath.concept && oldPath.concept.conceptName}</li>
                            </ul>}
                        </div>
                        <ul className='phaseList'>
                        {(newPath.concept && newPath.concept.conceptName) || newPath.chapter.chapterName}
                        </ul>
                    </div>
                </>)
               }
            })
            }
        </div>
    </div>);
  }

  isSaveRequired = () => {
    const { activeComponent, treeData } = this.props;
    switch (activeComponent) {
      case "CoursePlan":
        if (Object.keys(treeData).length > 0) {
          return true;
        }
        return false;
      case "View":
        return false;
      case "CreateCoursePlan":
        if (Object.keys(treeData).length <= 0) {
          return false;
        }
        return true;
      default:
        return true;
    }
  };

  callBackActiveComponent = () => {
    // this.props.handleComponentSwitching('CoursePlan');
    // this.props.handleTabSwitch('',0);
    this.handleBack();
  };

  handleSaveOnBack = () => {
    this.setState({ treeDataChange: false });
    this.toggleIsDialogOpen();
    this.props.handleSave(this.handleBack());
  };
  getStatusColorCode = (status: string) => {
    const { classes } = this.props;
    switch (status.toLowerCase()) {
      case "draft":
        return classes.draftColor;
      case "live":
        return classes.liveColor;
      case "past":
        return classes.pastColor;
      default:
        return classes.publishColor;
    }
  };
  handleEdit=()=>{
    const dataKey= !_.isEmpty(this.props.treeData)?'treeData':'coursePlanData';
    let isUpdateLocked = _.get(this.props, `${dataKey}.isUpdateLocked`, "");
    this.setState({
      showEditLockPopUp: isUpdateLocked || false,
    });
    if(!isUpdateLocked){
        this.props.handleEdit();
    }
  }
  handleRejection = (event: any) => {
    const { handleReject } = this.props;
    handleReject && handleReject();
  }

  getPublishText() {
    const { getPackageByIdData } = this.props;
    const publishRight = checkForPublishRight(MODULES.COURSE);
    const editedUser = checkForCreatedByUser(getPackageByIdData);
    let publishText = PUBLISH_OPTIONS.SUBMIT_REQUEST;
    if (publishRight || editedUser) {
      publishText = (editedUser || !getRequestId()) ? PUBLISH_OPTIONS.PUBLISH : PUBLISH_OPTIONS.ACCEPT_AND_PUBLISH;
    }
    return publishText;
  }

  isCourseRequestProcessed() {
    const { courseRequest } = this.props;
    const requestStatus = courseRequest && courseRequest.status

    return this.processedList.includes(requestStatus);
  }

  checkVisibleForPublish() {
    const { hidePublish, getPackageByIdData } = this.props;
    const visiblePublish = [];

    if (!hidePublish && !this.isCourseRequestProcessed()) {
      visiblePublish.push(checkForPublishRight(MODULES.COURSE));
      visiblePublish.push(checkForCreatedByUser(getPackageByIdData));
      visiblePublish.push(getPackageByIdData.status !== CONTENT_STATUS.DRAFT && checkForEditRight(getPackageByIdData, MODULES.COURSE));
    }
    return visiblePublish.some(visible => visible);
  }

  render = () => {
    const {
      name = "",
      status = "",
      handleSave,
      handlePublish,
      disablePublish,
      hideSave,
      hidePublish,
      showEdit,
      handleEdit,
      disableEdit,
      courseChangeData,
    } = this.props;
    const { isDailogOpen, treeDataChange, showEditLockPopUp, viewChangeVisible, } = this.state;
    const { classes, activeComponent, history } = this.props;
    const id = _.get(this.props, "match.params.id");
    let isSaveRequired = this.isSaveRequired();
    let { isSaveRequiredFromProps } = this.props;

    const {
      coursePlanDone,
      basicInfoDone,
      advancedSettingsDone,
      basicInfoValid,
      advancedSettingsValid,
      activeTab,
      isSaveDisable,
      canPublishCourse,
      duplicate,
      getPackageByIdData,
      hideDuplicate,
      isDifferentUser,
    } = this.props;

    const editContainerVisible = showEdit && checkForEditRight(getPackageByIdData, MODULES.COURSE);
    const createContainerVisible = !hideDuplicate && checkForCreationForRight(MODULES.COURSE);
    const rejectedRequestVisible = getRequestId() && checkForPublishRight(MODULES.COURSE);
    const showPublishReject=  this.checkVisibleForPublish();
    const courseDataTypes = REQUEST_CHANGES_KEYS;
  
    return (
      <>
       <MyPATDialog
          classes={{ root: classes.coursePlanRequestModal }}
          dialogOpen={viewChangeVisible}
          onDialogClose={false}
          otherDialogProps={{
              fullWidth: true,
              maxWidth: 'sm',
          }}
          customDialogActions={
              <>
                  <Grid container justify='flex-end'>
                      <Grid item>
                          <Button onClick={() => {this.handleConfirmation(false)}}>Cancel</Button>
                          <Button color='primary' variant='contained' className='btnBlue' onClick={()=> {this.handleConfirmation(true)}}>Yes, Proceed</Button>
                      </Grid>
                  </Grid>
              </>
          }
        >
          <h6 className='title'>
              Confirmation
          </h6>

          <div className='confirmationMessageBox'>
              <div className='confirmationMessage'>
                  <img src="/assets/svg/course-plan-request/clock-history-ic.svg" alt="Clock History" />
                  {!isDifferentUser && <p>You are trying to make following change(s) to this course that needs approval Are You sure you want to proceed and submit the request?</p>}
                  {isDifferentUser && <p>The following changes made to this course needs approval. But, the change request can't be placed at this moment as a separate request for this course has been made by another user. Please try again later. Do you want to proceed with publishing rest of the changes?</p>}
              </div>
              <p className='noteText'><strong>Note:</strong> All the other changes (if any) will be published directly</p>
          </div>

          <ul className='coursePlanRequestTab'>
              {COURSE_CHANGE_CONFIRMATION.map((courseChange, tabIndex) => (!!((courseChangeData[courseDataTypes[tabIndex]] || []).length) &&
                  <li className={cx({ 'active': this.state.activeTab === tabIndex })} onClick={() => this.handleTabClick(tabIndex)} key={tabIndex}><span>{courseChange}</span></li>)
              )}
          </ul>
          {this.getReorderChanges()}
          {this.getDateChanges()}
        </MyPATDialog>
        <Grid container justify="space-between" wrap="nowrap">
          <Grid
            item xs={7}
            style={{ marginBottom: "0", marginLeft: "3px", marginTop: "1px" }}
          >
            <span className={classes.dflex}>
              <span
                className={classes.backArrow}
                style={{ cursor: "pointer" }}
                onClick={
                  (activeComponent === "Selected" ||
                    activeComponent === "CreateCoursePlan") &&
                  treeDataChange &&
                  !this.state.isSaveClick
                    ? this.toggleIsDialogOpen
                    : () => this.handleBack()
                }
              >
                {/* <ArrowBackIcon/> */}
                {/* <img src="/assets/svg/left-arrowIcon.svg"/> */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 84">
                  <path
                    d="M32.7 15.9c1.4-1.4 3.6-1.4 5 0s1.4 3.6 0 5L12.1 46.4h84.3c2 0 3.5 1.6 3.5 3.5 0 2-1.6 3.6-3.5 3.6H12.1L37.7 79c1.4 1.4 1.4 3.7 0 5-1.4 1.4-3.7 1.4-5 0L1.1 52.5c-1.4-1.4-1.4-3.6 0-5l31.6-31.6z"
                    fill="#666"
                  />
                </svg>
              </span>
              &nbsp;
              <span className={classes.backArrowHeading}>{name}<Chip
              label={status !== "past" ? _.capitalize(status) : "Expired"}
              className={this.getStatusColorCode(status)}
              classes={{ label: classes.chipLabel, root: classes.chipStyle }}
              variant="outlined"
              component="a"
            /></span>
            </span>
            
          </Grid>

          <Grid item xs={5}>
            <Grid className={classes.btnGroup}>
              {(isSaveRequired || isSaveRequiredFromProps) && !hideSave && showPublishReject && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    this.setState(
                      { treeDataChange: false, isSaveClick: true },
                      () => handleSave()
                    )
                  }
                  disabled={isSaveDisable}
                >
                  Save
                </Button>
              )}

              {showPublishReject && (<>
                {rejectedRequestVisible &&
                  <Button
                    className='btn-text'
                    variant='contained'
                    color='primary'
                    onClick={this.handleRejection}
                  >
                    Rejected Request
                  </Button>}
                <Button
                  className='btn-blue'
                  disabled={
                    // !disablePublish
                    // || No need to check here pass disablePublish
                    !canPublishCourse
                    // || DON'T REMOVE !canPublishCourse
                    // (status.toLowerCase() !== "published" &&
                    //   !(
                    //     // coursePlanDone &&
                    //     basicInfoDone &&
                    //     advancedSettingsDone
                    //   )) ||
                    //   !canPublishCourse
                  }
                  variant="contained"
                  color="primary"
                  onClick={this.handleViewChanges}
                >
                  {this.getPublishText()}
                </Button>
              </>
              )}
              {editContainerVisible && (
                <Tooltip
                  placement="right-start"
                  title={
                    disableEdit
                      ? "You can edit course after the course is completely published"
                      : ""
                  }
                >
                  <Button
                    variant="contained"
                    className={classNames((disableEdit && classes.disabledCTA),classes.transparentButton)}
                    onClick={() => !disableEdit && handleEdit && this.handleEdit()}
                  >
                    Edit
                  </Button>
                </Tooltip>
              )}
              {createContainerVisible && (
                <Button
                  style={{
                    color: "#666666",
                    border: "1px solid #DDDDDD",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                    marginRight: "10px",
                  }}
                  color="primary"
                  onClick={duplicate}
                  className={classNames(
                    !this.props.hasDuplicateRight && classes.disabledCTA
                  )}
                  disabled={!this.props.hasDuplicateRight}
                >
                  Duplicate
                </Button>
              )}
              {/* <MyPATPopMenu
                    id="content-more-menu"
                    icon={MoreIcon}
                    menuItem={moreMenuItems}
                  /> */}
              <SaveAndProceed
                showPopupDialog={isDailogOpen}
                onSave={() => {
                  this.handleSaveOnBack();
                }}
                handleCancelOnPopup={() => {
                  this.toggleIsDialogOpen();
                }}
                dialogHeading="Save then proceed"
                dialogParaDetails="You need to save the content before canceling the request. This will help you to retain your data"
                saveButton="Save"
                cancleButton="Discard Changes"
              />
              {showEditLockPopUp && (
                <EditLockedInfoPopUp
                  showPopupDialog={showEditLockPopUp}
                  isEditMode={!hidePublish}
                  handleRedirectFunction={this.reDirectLandingPage}
                  onDialogClose={this.toggleEditPopUp}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };
}

// export default HeadingComponent;
// @ts-ignore
// export default withStyles(headerStyles)(withRouter(HeadingComponent));

const mapStateToProps = (state: any) => {
  return {
    getPackageByIdData: state.courseMangementData.contentManagementData.packageData,
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
    stopPollingStatusApi: _.get(state, 'courseMangementData.courseManagementReducer.stopPollingStatusApi', false),
    courseRequest: state.courseMangementData.courseManagementReducer.courseRequest,
    courseChangeData: state.courseMangementData.courseManagementReducer.courseChangeData,
    courseChangePayload: state.courseMangementData.courseManagementReducer.courseChangePayload,
    isDifferentUser: state.courseMangementData.courseManagementReducer.isDifferentUser,
  };
};
const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  resetAllState: contentManagementAction.resetAllState,
  rejectCourse
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(headerStyles)(withRouter(HeadingComponent)));
